import triggerOptionValues from 'config/postLogicTriggerValues';
import questionLogicUtils from 'utils/questionLogicUtils';

const getConditionalShowLogicQuestions = (blockList = []) => {
  const showLogicParentQuestions = blockList.filter(questionLogicUtils.isQuestionLogicShow);
  const showLogicConditionalQuestions = [];
  showLogicParentQuestions.forEach((questionBlock) => {
    questionBlock.logic.logicList.forEach(({ questionToJumpUuid, answerTriggerOption, logicAnswerValue }) => {
      const conditionalQuestionIndex = showLogicConditionalQuestions.findIndex(
        ({ questionUuid }) => questionUuid === questionToJumpUuid,
      );
      if (conditionalQuestionIndex !== -1) {
        showLogicConditionalQuestions[conditionalQuestionIndex].triggerConditions = [
          ...showLogicConditionalQuestions[conditionalQuestionIndex].triggerConditions,
          {
            controlQuestionId: questionBlock.id,
            answerTriggerOption: answerTriggerOption || triggerOptionValues.equal,
            logicTriggerValue: logicAnswerValue,
          },
        ];
      } else {
        showLogicConditionalQuestions.push({
          questionUuid: questionToJumpUuid,
          visible: false,
          triggerConditions: [
            {
              controlQuestionId: questionBlock.id,
              answerTriggerOption: answerTriggerOption || triggerOptionValues.equal,
              logicTriggerValue: logicAnswerValue,
            },
          ],
        });
      }
    });
  });
  return showLogicConditionalQuestions;
};

export default getConditionalShowLogicQuestions;
